/**
 * Styles for the dataset workspace, matching the Aineistot page (KnowledgeManager).
 */
import styled from '@emotion/styled';

export const Section = styled.section`
  margin-bottom: 28px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 6px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Lead = styled.p`
  margin: 0 0 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #999;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 12px;
`;

export const Card = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  text-align: left;
  padding: 14px 18px;
  margin-bottom: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  &:hover { border-color: rgba(147, 51, 234, 0.5); }
`;

export const CardTitle = styled.span`
  font-size: 15px;
  font-weight: 600;
`;

export const Meta = styled.span`
  font-size: 12px;
  color: #888;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

const STATUS_COLORS = {
  awaiting_file: '#a3a3a3',
  pending_download: '#60a5fa',
  pending_conversion: '#60a5fa',
  needs_review: '#fbbf24',
  pending_review: '#c084fc',
  approved: '#60a5fa',
  indexing: '#60a5fa',
  indexed: '#4ade80',
  rejected: '#a3a3a3',
  failed: '#f87171',
};

export const StatusChip = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  color: ${(p) => STATUS_COLORS[p.$status] || '#ccc'};
  border: 1px solid ${(p) => STATUS_COLORS[p.$status] || '#555'}55;
  background: ${(p) => STATUS_COLORS[p.$status] || '#555'}1a;
`;

// Source kind (#891): fact / policy / opinion / testimony; and the knowledge kinds
// (specs/knowledge-kinds.md), research in the colour of fact.
const KIND_COLORS = {
  fact: '#60a5fa', research: '#60a5fa', policy: '#4ade80', opinion: '#f472b6',
  testimony: '#22d3ee', statistics: '#a78bfa',
};

export const KindChip = styled.span`
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  white-space: nowrap;
  color: ${(p) => KIND_COLORS[p.$kind] || '#888'};
  border: 1px solid ${(p) => KIND_COLORS[p.$kind] || '#555'}55;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: #ddd;
  th {
    text-align: left;
    font-weight: 500;
    color: #888;
    padding: 8px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
  td {
    padding: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    vertical-align: top;
  }
  tr[data-clickable] { cursor: pointer; }
  tr[data-clickable]:hover td { background: rgba(255, 255, 255, 0.03); }
  a { color: #93c5fd; word-break: break-all; }
`;

export const Detail = styled.div`
  padding: 12px 4px 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Preview = styled.pre`
  max-height: 360px;
  overflow: auto;
  margin: 0;
  padding: 12px;
  background: #0d0d14;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  color: #ccc;
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #f87171;
`;

export const TableScroll = styled.div`
  overflow-x: auto;
`;
